import moment from 'moment'
import { type StartAndEndDeliveryHour } from 'domains/shifts/components/components/weekly-staffing/utils/types'
import { type DeliveryHours } from 'domains/shifts/components/types'

/**
 * Returns the start and end hour of day (e.g. 1pm = 13) from delivery hours, taking date changes into account.
 */
export const getDayStartAndEndHours: (
  regularHours: DeliveryHours
) => StartAndEndDeliveryHour = regularHours => {
  const startMoment = moment(regularHours.start)
  const endMoment = moment(regularHours.end)

  const start = startMoment.hours()
  let end = endMoment.hours()

  // if end time is next day from the start time, e.g. store closes at 12am, we add 24 hours
  if (endMoment.startOf('day').isAfter(startMoment.startOf('day'))) {
    end += 24
  }

  return {
    start,
    end,
  }
}
